import React from "react";
import { useTable } from "../../Components/useTable";

const MomentsVideoApprove = () => {
  const type = "Active Video Moments";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "User RID" },
    { id: "username", numeric: false, label: "User Name" },
    { id: "picture", numeric: false, label: "Profile Image" },
    // { id: "country", numeric: false, label: "Country" },
    { id: "videoUrl", numeric: false, label: "Moment Video" },
    { id: "status", numeric: false, label: "Status" },
    { id: "dropdown2", numeric: false, label: "Change Status" },
    { id: "description", numeric: false, label: "Description" },
    // { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default MomentsVideoApprove;
